import { render, staticRenderFns } from "./updateEventIntroduce.vue?vue&type=template&id=5897836c&scoped=true&"
import script from "./updateEventIntroduce.vue?vue&type=script&lang=ts&"
export * from "./updateEventIntroduce.vue?vue&type=script&lang=ts&"
import style0 from "./updateEventIntroduce.vue?vue&type=style&index=0&id=5897836c&lang=scss&scoped=true&"
import style1 from "./updateEventIntroduce.vue?vue&type=style&index=1&id=5897836c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5897836c",
  null
  
)

export default component.exports